import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import MilitaryForm from './MilitaryForm';
import MilitaryInformationDisplay from './components/MilitaryInformationDisplay';
import EditModal from '../common/modal/EditModal';
var MilitaryInformation = function MilitaryInformation(props) {
  var modalRef = useRef();
  var contact = props.contact,
    hideHeader = props.hideHeader;
  var militaryInfo = function militaryInfo() {
    if (!contact.has_military) {
      return /*#__PURE__*/React.createElement("span", {
        className: "military-information-add-info",
        onClick: function onClick() {
          return modalRef.current.openModal();
        },
        role: "button",
        tabIndex: 0
      }, "Add Military Information");
    }
    return /*#__PURE__*/React.createElement(MilitaryInformationDisplay, {
      action: '',
      contact: contact
    });
  };
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Military Information",
    size: "normal",
    formName: "military-info",
    editButtonId: "military-info-btn",
    id: "military-info-modal",
    "aria-label": "edit military information",
    ref: modalRef
  }, /*#__PURE__*/React.createElement(MilitaryForm, {
    contact: contact
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "profile-panel military-information editable-panel"
  }, /*#__PURE__*/React.createElement("div", null, !hideHeader && /*#__PURE__*/React.createElement("h3", null, "Military Information"), /*#__PURE__*/React.createElement("div", {
    className: "section-body"
  }, militaryInfo(), editSection)));
};
MilitaryInformation.propTypes = {
  contact: PropTypes.object.isRequired,
  hideHeader: PropTypes.bool
};
MilitaryInformation.defaultProps = {
  hideHeader: false
};
export default MilitaryInformation;
//# sourceMappingURL=index.js.map